import { BadgeTone } from '../../constants';
import styles from './ServiceBadge.module.scss';

interface ServiceBadgeProps {
  label: string;
  tone: BadgeTone;
}

/** Solid pill for anything a client subscribes to -- a plan tier or an add-on. */
const ServiceBadge = ({ label, tone }: ServiceBadgeProps) => <span className={`${styles.badge} ${styles[tone]}`}>{label}</span>;

export default ServiceBadge;
